import type { IconKey } from "./EcommerceReassuranceBanner";

// This is a mapping of the icon names to the actual icon components used in jti-next
export const dropdownMapper: Record<string, IconKey> = {
  Account: "account",
  "Check + round": "checkMarkWithRoundBorder",
  "Check Plus Circle": "checkPlusCircle",
  "Credit card + lock": "cardWithLock",
  "ZERO tobacco": "zeroTobacco",
  "Easy to maintain": "easyToMaintain",
  Edit: "edit",
  "Falling plus": "falling",
  "Ingredients - Fibers": "ingredientFibers",
  "Ingredients - Flavoring": "ingredientFlavoring",
  "Ingredients - Gumbase": "ingredientGumbase",
  "Ingredients - Nicotine": "ingredientNicotine",
  "Lock Outline Close": "lockOutlineClose",
  "Minimal cleaning": "minimalCleaning",
  "Mouth tingle": "mouthTingle",
  "Mouth under lip": "mouthUnderLip",
  "No ash": "noAsh",
  "No smoke smell": "noSmokeSmell",
  "Package + arrow": "packageWithArrow",
  "Package + checkmark": "packageWithCheckMark",
  "Package + clock": "packageWithClock",
  "Package return": "packageReturn",
  "Package shopping": "packageShopping",
  Package: "package",
  "Pin - time & place": "pinTimePlace",
  "Pleasant aroma": "pleasantAroma",
  "Pouch - dispose": "pouchDispose",
  "Profile - family": "profileFamily",
  Timer: "timer",
  "Tobacco leaf": "tobaccoLeaf",
  "Auto-On": "autoOnIcon",
  Bluetooth: "bluetooth",
  "Local Reward": "localRewardIcon",
  "Profile Gear": "profileGearIcon",
} as const;
